<template>
  <div class="card">
    <div class="card-body">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <div class="upload-wrap">
              <file-uploader
                v-model="localStart.afisha_link"
                :default="localStart.afishaLinkFile"
                title="Афиша старта"
              />
            </div>
          </b-col>

          <b-col md="6">
            <div class="upload-wrap">
              <file-uploader
                v-model="localStart.poster_link"
                :default="localStart.posterLinkFile"
                title="Обложка старта"
              />
            </div>
          </b-col>

          <b-col cols="12">
            <div class="condition-files-section">
              <h5 class="condition-files-section__title">Положение старта</h5>
              <div
                v-for="(item, index) in conditionFiles"
                :key="'condition-file-' + (item.id || index)"
                class="condition-files-section__item"
              >
                <div class="condition-files-section__item-header">
                  <span class="condition-files-section__item-label">Файл {{ index + 1 }}</span>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="removeConditionFile(index)"
                  >
                    Удалить
                  </b-button>
                </div>
                <file-uploader
                  v-model="item.file_id"
                  :default="item.file"
                  :title="'Вложение ' + (index + 1)"
                />
                <b-form-input
                  v-model="item.name"
                  class="condition-files-section__name-input"
                  placeholder="Название (например: Положение 2026)"
                />
              </div>
              <b-button
                variant="primary"
                class="condition-files-section__add-btn"
                @click="addConditionFile"
              >
                Добавить положение
              </b-button>
            </div>
          </b-col>

          <b-col md="6">
            <div class="upload-wrap">
              <file-uploader
                v-model="localStart.small_image"
                :default="localStart.smallImageFile"
                title="Доп. изображение"
              />
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { BForm, BRow, BCol, BButton, BFormInput } from 'bootstrap-vue'
import FileUploader from '@/global-components/FileUploader.vue'

export default {
  name: 'StartImagesSection',

  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormInput,
    FileUploader,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  computed: {
    localStart: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    conditionFiles: {
      get() {
        if (!Array.isArray(this.localStart.condition_files)) {
          this.$set(this.localStart, 'condition_files', [])
        }
        return this.localStart.condition_files
      },
      set(val) {
        this.$set(this.localStart, 'condition_files', val)
      },
    },
  },

  methods: {
    addConditionFile() {
      this.conditionFiles.push({
        name: '',
        file_id: null,
        file: null,
      })
    },
    removeConditionFile(index) {
      this.conditionFiles.splice(index, 1)
    },
  },
}
</script>

<style scoped lang="scss">
.upload-wrap {
  margin-bottom: 20px;
}

.condition-files-section {
  margin-bottom: 20px;
}

.condition-files-section__title {
  margin-bottom: 16px;
}

.condition-files-section__item {
  padding: 0 0 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #d8d6de;
  border-radius: 0;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.condition-files-section__item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.condition-files-section__item-label {
  font-weight: 600;
}

.condition-files-section__name-input {
  margin-top: 12px;
}

.condition-files-section__add-btn {
  margin-top: 4px;
}
</style>

<style lang="scss">
.dark-layout {
  .condition-files-section__item {
    border-bottom-color: #3b4253;
  }
}
</style>
